var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.369 0.609112C16.085 0.325136 15.6245 0.325088 15.3405 0.609161L8.5822 7.36761L1.82356 0.609112C1.53958 0.325136 1.07907 0.325088 0.795049 0.609161C0.511025 0.893185 0.511025 1.35365 0.795049 1.63767L8.06797 8.9104C8.20436 9.04678 8.38933 9.12339 8.5822 9.12339C8.77507 9.12339 8.96009 9.04674 9.09643 8.91035L16.369 1.63762C16.653 1.35365 16.653 0.893136 16.369 0.609112Z",
    fill: "#01244E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.a9ba501ae268ebb2b5e379a9ab7fa195.svg";
export { ForwardRef as ReactComponent };